import {Button} from 'antd';
import React from 'react';
import './index.style.less';
import AppModal from '../AppModal';

const AppConfirmPopup = ({
  loading,
  visible,
  setVisible,
  handleOK,
  title,
  okText,
  cancelText,
  logoUrl,
}: any) => {
  return (
    <AppModal
      width={'420px'}
      visible={visible}
      footer={<></>}
      onCancel={() => setVisible && setVisible(false)}>
      <div className={'confirmPopup'}>
        {/* A given logo (a shop admin's shop) fitted on white; otherwise the
            Ahlan bag on the brand tint, as the store design's marks. */}
        {logoUrl ? (
          <div className={'confirmLogo confirmLogo-image'}>
            <img src={logoUrl} alt='' />
          </div>
        ) : (
          <div className={'confirmLogo'}>
            <img src='/assets/images/ahlan-bag.svg' alt='' />
          </div>
        )}
        <div className={'confirmTitle'}>{title}</div>
        <div className={'action'}>
          <Button
            onClick={() => {
              setVisible && setVisible(false);
            }}>
            {cancelText}
          </Button>
          <Button loading={loading} type={'primary'} onClick={handleOK}>
            {okText}
          </Button>
        </div>
      </div>
    </AppModal>
  );
};

export default AppConfirmPopup;
